<template>
    <div>
        <div class="margin-left-15">ERPSKU:<span class="font-weight">{{comperpsku.erpsku}}</span> &nbsp; {{$t('erp.product.stock_total', { defaultValue: '库存总数量' })}}:<span class="font-weight">{{comperpsku.qty}}</span></div>
        <compTablelist class="margin-layout" :columns="columns" v-bind="getCostTableProps"></compTablelist>
    </div>
</template>
<script>
// HttpGetInventoryList
import { HttpGetInventoryList } from '@/service/products/allproducts';
export default {
    props:['comperpsku','typedata', 'isProductManage', 'isManage'],
    components:{
        compTablelist: () => import("@components/templates/tablelist"),
    },
    data(){
        return {
            // formList:[],
        }
    },
    computed:{
        getCostTableProps() {
			return {
				initFormData:{
                    'search[EQ_organizationId]': this.isProductManage?'':global.SYSID,
                    state: this.isManage? 1 : 0,
                    'search[RCN_sku]': this.comperpsku.erpsku,
				},
				startUp:true,
				ajaxRequest: HttpGetInventoryList,
                interceptResponse: (data,_this) => {
                    let array = [];
                    if(this.typedata == 'listinginventory'){
                        data.content.map(item=>{
                            if(item.warehouseType != 2){
                                array.push(item)
                            }
                        })
                        _this.dataList = array
                    }
				},
			};
		},
        columns(){
            return [
                {
                    title: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
                    key:'orgWarehouseName'
                },
                {
                    title: this.$t('fbb.inbound.inventory_type', { defaultValue: "库存类型" }),
                    key:'inventoryType',
                    render(h,{row}){
                        switch(row.inventoryType){
                            case 0: return this.$t('erp.product.normal_stock', { defaultValue: '正常库存' });break;
                            case 1: return this.$t('fbb.inbound.unavailable_stock', { defaultValue: '不可售库存' });break;
                        }
                    }
                },
                {
                    title: this.$t('erp.product.available', { defaultValue: "可用" }),
                    key:'inventoryAvailable'
                },
                {
                    title: this.$t('erp.product.reserved', { defaultValue: "预留" }),
                    key:'inventoryReserved'
                },
                {
                    title: "在途",
                    key:'inventoryTransport'
                },
                {
                    title: "总库存",
                    key:'inventoryCurrent'
                },
            ]
        }
    },
}
</script>
